module.exports = new __parcel__URL__("79343_h.5cc9ffbf.jpg").toString();